import { createFileRoute, redirect } from '@tanstack/react-router';
import { documentTypesQueryOptions } from '@/hooks/useDocumentsQuery';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute('/(client)/documents/(pages)')({
  beforeLoad: ({ location }) => {
    if (
      location.pathname === '/documents' ||
      location.pathname === '/documents/'
    ) {
      throw redirect({ to: '/documents/my-documents' });
    }
  },
  // Pre-fetch document types once for the whole documents section
  loader: () => queryClient.ensureQueryData(documentTypesQueryOptions()),
});
